<form class="form-horizontal" [formGroup]="salariedForm">
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-user'></i> Datos Generales
    </span>
    <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Empresa</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="companyType"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <ng-select formControlName="companyType" [items]="companyTypes" bindLabel="value" bindValue="key"
          [readonly]="readonly"></ng-select>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Nombre de Lugar de Trabajo</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="companyName"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="companyName"
          [ngClass]="salariedForm.controls.companyName.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        <!--  -->
      </div>
    </div>
    <div class="form-group row">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Salario Mensual</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="monthlySalaryAmount"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="number" class="form-control" formControlName="monthlySalaryAmount"
          [ngClass]="salariedForm.controls.monthlySalaryAmount.errors ? 'is-invalid' : 'is-valid'"
          [readonly]="readonly">
        <!--  -->
      </div>
    </div>
    <div class="form-group row">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Fecha de Ingreso</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="startDate"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input bsDatepicker class="form-control" formControlName="startDate"
          [bsConfig]="{ isAnimated: true, containerClass:'theme-blue', displayOneMonthRange: true, selectFromOtherMonth:true }"
          [ngClass]="salariedForm.controls.startDate.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        <!--  -->
      </div>
    </div>
  </accordion-group>
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-list'></i> Información Complementaria
    </span>
    <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Tipo de Contrato</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="workContractType"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <ng-select formControlName="workContractType" [items]="workContractTypes" bindLabel="value" bindValue="key"
          [readonly]="readonly"></ng-select>
      </div>
    </div>
    <div class="form-group row">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Departamento en que labora</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="workDepartmentName"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="workDepartmentName"
          [ngClass]="salariedForm.controls.workDepartmentName.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        <!--  -->
      </div>
    </div>
    <div class="form-group row" *ngIf="!isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Cargo</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="workPosition"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="workPosition"
          [ngClass]="salariedForm.controls.workPosition.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
        <!--  -->
      </div>
    </div>
  </accordion-group>
  <accordion-group [isOpen]="true">
    <span accordion-heading>
      <i class='fa fa-map-marker'></i> Información de Ubicación
    </span>
    <div class="row">
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Pais</b>
          <span appRequiredAsterisk [formGroup]="salariedForm" controlName="country"></span>
        </label>
        <ng-select formControlName="country" [items]="nationalities" bindLabel="country" bindValue="code"
          (change)="changeCountry($event)" [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Departamento</b>
          <span appRequiredAsterisk [formGroup]="salariedForm" controlName="deparment"></span>
        </label>
        <ng-select formControlName="deparment" [items]="departments" bindLabel="name" bindValue="region"
          (change)="changeDepartment($event)" [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Ciudad</b>
          <span appRequiredAsterisk [formGroup]="salariedForm" controlName="city"></span>
        </label>
        <ng-select formControlName="city" [items]="cities" bindLabel="name" bindValue="cityCode"
          (change)="changeCity($event)" [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
      <div class="form-group col-md-3">
        <label class="col-form-label"><b>Colonia</b>
          <span appRequiredAsterisk [formGroup]="salariedForm" controlName="neighborhood"></span>
        </label>
        <ng-select formControlName="neighborhood" [items]="neighborhoods" bindLabel="name" bindValue="code"
          [clearable]="false" [readonly]="readonly"></ng-select>
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 1</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="street"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street"
          [ngClass]="salariedForm.controls.street.errors ? 'is-invalid' : 'is-valid'" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 2</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="street2"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street2" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 3</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="street3"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street3" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 4</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="street4"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street4" [readonly]="readonly">
      </div>
    </div>
    <div class="form-group row" *ngIf="!hideStreet && !isShortFormActiveForPlan">
      <label class="col-8 col-md-2 col-sm-4 col-form-label"><b>Calle 5</b>
        <span appRequiredAsterisk [formGroup]="salariedForm" controlName="street5"></span>
      </label>
      <div class="col-10 col-md-10 col-sm-8 ">
        <input type="text" class="form-control" formControlName="street5" [readonly]="readonly">
      </div>
    </div>
  </accordion-group>
  <accordion-group [isOpen]="true" *ngIf="!hidePhone && !isShortFormActiveForPlan">
    <span accordion-heading>
      <i class='fa fa-phone'></i> Información de Teléfonos
    </span>
    <div class="row">
      <div class="form-group col-md-8">
        <label class="col-form-label"><b>Teléfono</b>
          <span appRequiredAsterisk [formGroup]="salariedForm" controlName="companyPhone"></span>
        </label>
        <input type="text" class="form-control" formControlName="companyPhone"
          [ngClass]="salariedForm.controls.companyPhone.errors ? 'is-invalid' : 'is-valid'" [mask]="currentMask"
          [showMaskTyped]="true" [readonly]="readonly">
      </div>
      <div class="form-group col-md-4">
        <label class="col-form-label"><b>Extensión</b>
          <span appRequiredAsterisk [formGroup]="salariedForm" controlName="companyExtension"></span>
        </label>
        <input type="text" class="form-control" formControlName="companyExtension" [readonly]="readonly">
      </div>
    </div>
  </accordion-group>
</form>